import React, { useCallback, useEffect, useRef, useState } from "react";
import "./DocumentViewer.css";
import searchIcon from "../../common/assets/images/Search.png";
import plusIcon from "../../common/assets/images/plus_icon.png";
import minsIcon from "../../common/assets/images/mins-icon.png";
import externalIcon from "../../common/assets/images/link-external.png";
import documentationIcon from "../../common/assets/images/documentation.png";
import {Accordion, Pagination, Card, Spinner } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { getDocumentViewerData, searchDocumentViewerData, setDocumentviewerPage, setDocumentviewerSearchValue, resetDocumentviewerSearchValue, setDocumentviewerEventKey, setDocumentviewerSelectedDocumentData, setEpisodeIdentifierTopassDocumentViewer, resetDocumentViewerError, resetAIJustificationData} from "./redux/DocumentViewerSlicer";
import LdsRoller from "../../utils/LdsRoller";
import { useDispatch, useSelector } from "react-redux";
import DOMPurify from 'dompurify';

const DocumentViewer = ({ episodeList }) => {
  const cardRefs = useRef([]);
  const location = useLocation();
  const dispatch = useDispatch();
  const currentScreen = sessionStorage.getItem("currentPage");
  // let selectedEpisodeIdentifier = null;
  // if (currentScreen === "episodeList") {
  let selectedEpisodeIdentifier = episodeList?.selectedEpisode?.episode_identifier;
  // } else if (currentScreen === "coderview" || currentScreen === "auditorPage") {
  // selectedEpisodeIdentifier = episodeList?.selectedEpisode?.medical_record_number;
  // }
  // const selectedEpisodeIdentifier = currentScreen === "episodeList" ? episodeList?.selectedEpisode?.episode_identifier : currentScreen === "coderview" || currentScreen === "auditorPage" ? episodeList?.selectedEpisode?.medical_record_number;
  const lastCodedEpisode = useSelector((state) => state.documentViewer);
  // const [episodeIdentifierTopassDocumentViewer, setEpisodeIdentifierTopassDocumentViewer] = useState("");
  // const { documentviewerCurrentPage } = useSelector((state) => state.documentViewer);
  const { documentViewerData, documentViewerDataLoader, documentViewerDataError } = useSelector((state) => state.documentViewer.documentViewer);
  // const { documentSearchValue, documentSearchValueLoading, documentSearchValueError } = useSelector((state) => state.documentViewer.documentViewerSearch);
  // const {documentviewerSearchValue} = useSelector((state) => state.documentViewer);
  const { documentviewerCurrentPage, documentviewerSearchValue, documentviewerEventKey, documentviewerSelectedDocumentData, episodeIdentifierTopassDocumentViewer } = useSelector((state) => state.documentViewer);
  // const [documentviewerSearchValue, setDocumentviewerSearchValue] = useState("");
  const [documentviewerRowsPerPage, setDocumentviewerRowsPerPage] = useState(5);
  const [filteredDocumentsList, setFilteredDocumentsList] = useState([]);
  const [aiDocumentLoading, setAiDocumentLoading] = useState(false);
  // const [eventKey, setEventKey] = useState(null);
  // const [documentPage, setDocumentPage] = useState(1)
  // const [selectedDocumentData, setSelectedDocumentData] = useState({
  //   documentID: null,
  //   documentContent: "",
  //   documentName: "",
  // });
  const aiJustificationData = useSelector(
  (state) => state.documentViewer.aiJustificationData
);
const isAIReasoningMode =
  Boolean(aiJustificationData?.document_name);

  const toggleAccordion = (id) => { 
    dispatch(setDocumentviewerEventKey(id === documentviewerEventKey ? null : id));
  };

  
  // useEffect(() => {
  //   if (!documentViewerDataError && selectedEpisodeIdentifier !== undefined) {
  //     dispatch(setEpisodeIdentifierTopassDocumentViewer(selectedEpisodeIdentifier));
  //     dispatch(resetDocumentviewerSearchValue())
  //   }
  //     // console.log('Error occurred, episodeIdentifier reset');

  // }, [documentViewerDataError, selectedEpisodeIdentifier, dispatch]);
   
  useEffect(() => {
  if (!documentViewerDataError && selectedEpisodeIdentifier !== undefined) {
    // New episode selected — clear any AI-justification state left over
    // from a previously viewed episode. Otherwise isAIReasoningMode stays
    // true and the accordion keeps filtering by a document_name that
    // doesn't exist in the new episode's document list.
    dispatch(resetAIJustificationData());
    dispatch(setDocumentviewerEventKey(null));
    dispatch(
      setDocumentviewerSelectedDocumentData({
        documentID: null,
        documentContent: "",
        documentName: "",
      })
    );

    dispatch(setEpisodeIdentifierTopassDocumentViewer(selectedEpisodeIdentifier));
    dispatch(resetDocumentviewerSearchValue());
  }
}, [documentViewerDataError, selectedEpisodeIdentifier, dispatch]);
  useEffect(() => {
    // console.log(episodeIdentifierTopassDocumentViewer, 'im here')
  if(episodeIdentifierTopassDocumentViewer?.length > 0  && documentviewerCurrentPage !== undefined){
      dispatch(getDocumentViewerData({documentEpisodeIdentifier: episodeIdentifierTopassDocumentViewer, documentCurrentPage: documentviewerCurrentPage}));
    }
  }, [episodeIdentifierTopassDocumentViewer]);


  const indexOfLastDocument = documentviewerCurrentPage * documentviewerRowsPerPage;
  const indexOfFirstDocument = indexOfLastDocument - documentviewerRowsPerPage;
  // const currentDocumentsList = documentViewerData?.documents
  // ?.slice(indexOfFirstDocument, indexOfLastDocument) || [];

const totalDocuments = Number(documentViewerData?.total_documents) || 0;
const currentPage = Number(documentviewerCurrentPage);
const rowsPerPage = Number(documentviewerRowsPerPage);
const isValid = Number.isFinite(currentPage) && Number.isFinite(rowsPerPage) && currentPage > 0 && rowsPerPage > 0;
const start = isValid ? (currentPage - 1) * rowsPerPage + 1 : '-';
const end = isValid ? Math.min(currentPage * rowsPerPage, totalDocuments) : '-';

  const totalPages = documentViewerData?.total_documents ? Math.ceil(documentViewerData.total_documents / documentviewerRowsPerPage) : 0;

  const checkCardHeight = (index) => {
    if (isAIReasoningMode) {
    return;
  }
    const documentsDocumentCategoryId = filteredDocumentsList?.length > 0 ? filteredDocumentsList?.map((item) => item.document_patient_document_id) : [];
    const minDocumentID  = Math.min(...documentsDocumentCategoryId)
    const maxDocumentID  = Math.max(...documentsDocumentCategoryId)
    const currentCardBody = cardRefs.current[index];
    if (currentCardBody) {
      let scrollPosition = Math.floor(currentCardBody.scrollTop);
      const cardHeight = currentCardBody.clientHeight;
      const cardContentHeight = currentCardBody.scrollHeight;
    if (location.pathname === "/document-viewer" || true) {
      const currentDocumentIndex = documentsDocumentCategoryId.indexOf(index);
      if (scrollPosition + cardHeight >= cardContentHeight - 1) { 
        const newDocumentIndex  = documentsDocumentCategoryId[currentDocumentIndex + 1]
          if (newDocumentIndex >= minDocumentID) {
            // setEventKey(newDocumentIndex);
            dispatch(setDocumentviewerEventKey(newDocumentIndex));
            const selectedData = {
              ...documentviewerSelectedDocumentData,
              documentID: newDocumentIndex,
            }
            dispatch(setDocumentviewerSelectedDocumentData(selectedData))
            // setSelectedDocumentData((prev) => ({
            //   ...prev,
            //   documentID: newDocumentIndex,
            // }));
          }
        } else if (scrollPosition <= 0) {
        const newDocumentPrevIndex  = documentsDocumentCategoryId[currentDocumentIndex - 1]
            // const prevIndex = index + 1;
            if (newDocumentPrevIndex <= maxDocumentID) { 
              // setEventKey(newDocumentPrevIndex);
            dispatch(setDocumentviewerEventKey(newDocumentPrevIndex));
            const selectedData = {
              ...documentviewerSelectedDocumentData,
              documentID: newDocumentPrevIndex,
            }
            dispatch(setDocumentviewerSelectedDocumentData(selectedData))
              // setSelectedDocumentData((prev) => ({
              //   ...prev,
              //   documentID: newDocumentPrevIndex,
              // }));
            }
          }
        }
      } else {
        console.log('No card found');
      }
    };

    useEffect(() => {
      dispatch(setDocumentviewerPage(1));
    }, [])

    useEffect(() => {
      if (documentViewerData !== undefined && documentViewerData.documents !== undefined) {
        setFilteredDocumentsList(documentViewerData.documents)
      }
    }, [documentViewerData]); // Add documentViewerData to dependencies to re-run when it changes
    
    useEffect(() => {
  let cancelled = false;

  const findAndLoadAIDocument = async () => {
    if (!aiJustificationData?.document_name) return;

    // 1. Check the page that's already loaded first — cheapest path.
    const localMatch = filteredDocumentsList?.find(
      (documentData) =>
        documentData?.document_name === aiJustificationData?.document_name
    );

    if (localMatch) {
      dispatch(setDocumentviewerEventKey(localMatch.document_patient_document_id));
      dispatch(
        setDocumentviewerSelectedDocumentData({
          documentID: localMatch.document_patient_document_id,
          documentContent: localMatch.document_text,
          documentName: localMatch.document_name,
        })
      );
      return;
    }

    // 2. Not on this page — search the other pages.
    if (!episodeIdentifierTopassDocumentViewer) return;

    const total = Number(documentViewerData?.total_documents) || 0;
    const perPage = documentviewerRowsPerPage || 5;
    const totalPagesCount = perPage > 0 ? Math.ceil(total / perPage) : 0;

    if (totalPagesCount <= 1) return; // nothing else to search

    setAiDocumentLoading(true);
    const originalPage = documentviewerCurrentPage;

    try {
      for (let page = 1; page <= totalPagesCount; page++) {
        if (page === originalPage) continue; // already checked above
        if (cancelled) return;

        // NOTE: assumes getDocumentViewerData is a createAsyncThunk
        // (RTK) so .unwrap() resolves with the fulfilled payload.
        // If it isn't, swap this for however your thunk exposes its
        // resolved data.
        const result = await dispatch(
          getDocumentViewerData({
            documentEpisodeIdentifier: episodeIdentifierTopassDocumentViewer,
            documentCurrentPage: page,
          })
        ).unwrap();

        const found = result?.documents?.find(
          (documentData) =>
            documentData?.document_name === aiJustificationData?.document_name
        );

        if (found) {
          dispatch(setDocumentviewerPage(page));
          dispatch(setDocumentviewerEventKey(found.document_patient_document_id));
          dispatch(
            setDocumentviewerSelectedDocumentData({
              documentID: found.document_patient_document_id,
              documentContent: found.document_text,
              documentName: found.document_name,
            })
          );
          return;
        }
      }

      // Not found anywhere — restore the page the user was on.
      dispatch(
        getDocumentViewerData({
          documentEpisodeIdentifier: episodeIdentifierTopassDocumentViewer,
          documentCurrentPage: originalPage,
        })
      );
    } catch (err) {
      console.error("Error while searching for AI justification document:", err);
    } finally {
      if (!cancelled) setAiDocumentLoading(false);
    }
  };

  findAndLoadAIDocument();

  return () => {
    cancelled = true;
  };
}, [aiJustificationData]);
// useEffect(() => {
//   if (
//     aiJustificationData?.document_name &&
//     filteredDocumentsList?.length > 0
//   ) {
//     const aiDocument = filteredDocumentsList.find(
//       (documentData) =>
//         documentData?.document_name ===
//         aiJustificationData?.document_name
//     );

//     if (aiDocument) {
//       dispatch(
//         setDocumentviewerEventKey(
//           aiDocument.document_patient_document_id
//         )
//       );

//       dispatch(
//         setDocumentviewerSelectedDocumentData({
//           documentID:
//             aiDocument.document_patient_document_id,
//           documentContent: aiDocument.document_text,
//           documentName: aiDocument.document_name,
//         })
//       );
//     }
//   }
// }, [
//   aiJustificationData,
//   filteredDocumentsList,
//   dispatch,
// ]);
  const handleDocumentViewerPageChange = (pageNumber) => {
    const params = new URLSearchParams(window.location.search);
    const getQueryEpisodeIdentifier = params.get("episode_identifier_number");
    if (pageNumber > 0 && pageNumber <= documentViewerData?.total_documents) {
      // setDocumentviewerCurrentPage(pageNumber);
      // const documentEpisodeIdentifier = episodeIdentifierTopassDocumentViewer?.length > 0  && documentviewerCurrentPage !== undefined ? episodeIdentifierTopassDocumentViewer
      // episodeIdentifierTopassDocumentViewer?.length > 0  && documentviewerCurrentPage !== undefined
      const selectedData = {
        ...documentviewerSelectedDocumentData,
        documentID: null,
      }
      // setSelectedDocumentData((prev) => ({
      //   ...prev,
      //   documentID: null,
      // }));
      dispatch(resetDocumentViewerError());
      dispatch(setDocumentviewerEventKey(null));
      dispatch(setDocumentviewerSelectedDocumentData(selectedData));
      dispatch(setDocumentviewerPage(pageNumber));
      if(episodeIdentifierTopassDocumentViewer?.length > 0  && pageNumber !== undefined){
        dispatch(getDocumentViewerData({documentEpisodeIdentifier: episodeIdentifierTopassDocumentViewer, documentCurrentPage: pageNumber}));
      }
    }
  };


  const documentSearchHandler = (event) => {
    // setDocumentviewerSearchValue(event.target.value);
    dispatch(setDocumentviewerSearchValue(event.target.value));
  };

  // const debouncedSearch = useCallback(
  //   debounce(async (query, episodeIdentifier) => {
  //     const params = new URLSearchParams(window.location.search);
  //     const getQueryEpisodeIdentifier = params.get("episode_identifier_number");
      
  //       const payload = { 
  //       episode_identifier: episodeIdentifierTopassDocumentViewer !== undefined ? episodeIdentifierTopassDocumentViewer : episodeIdentifier !== undefined ? episodeIdentifier : getQueryEpisodeIdentifier,
  //       document_name: selectedDocumentData?.documentName ?? "",
  //       search_term: query ?? "",
  //     };
  //   // console.log(payload, 'payload')
  //     // dispatch(searchDocumentViewerData(payload));
  //   }, 200),
  //   [episodeIdentifierTopassDocumentViewer, selectedDocumentData, dispatch]
  // );

  const documentSelectedHandler = (documentData) => {
    const params = new URLSearchParams(window.location.search);
    const newEpisodeIdentifier = params.get("episode_identifier_number");
    
    const episode_identifier_to_pass = episodeIdentifierTopassDocumentViewer
      ? episodeIdentifierTopassDocumentViewer
      : newEpisodeIdentifier;
  
    // Prepare the data to pass
    const data = {
      // documentName: documentData.document_name?.toLowerCase()?.replace(/\.txt/g, ""),
      // documentName: documentData.document_name?.slice(documentData.document_name.indexOf("-") + 1),
      documentName: documentData?.document_name?.replace(".txt", "")?.slice(documentData?.document_name?.indexOf("-") + 1),
      eventKey: documentviewerEventKey,
      searchValue: documentviewerSearchValue,
      episode_identifier_number: episode_identifier_to_pass,
      page: documentviewerCurrentPage,
      aiJustificationDocumentName: aiJustificationData?.document_name ?? null,
    aiJustificationEvidence: aiJustificationData?.evidence ?? null,
    };
    sessionStorage.setItem('documentViewerData', JSON.stringify(data));
    window.open('/document-viewer', '_blank');
  
  };
  

  const addTooltipToSpans = (reasoningContent, documentCodes) => {
    return reasoningContent?.replace(/(<span[^>]*>)/g, (text) => {
      return text.replace('<span', `<span data-tooltip=${documentCodes}`);
    });
  };
    
//   const highlightEvidenceText = (documentText, evidence) => {
//   if (!documentText || !evidence) {
//     return documentText;
//   }

//   // Clean API evidence
//   const cleanedEvidence = evidence
//     .replace(/\\n/g, "\n")       // literal \n
//     .replace(/\*\*/g, "")        // remove **
//     .replace(/\\+$/g, "")        // remove trailing \
//     .trim();

//   // Split evidence into individual lines
//   const evidenceParts = cleanedEvidence
//     .split(/\r?\n/)
//     .map((text) => text.trim())
//     // Strip wrapping quote marks (straight + curly) — these come from the
//     // AI's evidence formatting, but the underlying document text never
//     // actually contains literal quote characters around the sentence,
//     // so leaving them in makes the regex match nothing.
//     .map((text) =>
//       text.replace(/^["'“”‘’]+|["'“”‘’]+$/g, "").trim()
//     )
//     .filter(
//       (text) =>
//         text &&
//         text !== "..." &&
//         text.length > 2
//     );

//   let result = documentText;

//   evidenceParts.forEach((evidencePart) => {
//     const normalizedEvidence = evidencePart
//       .replace(/\s+/g, " ")
//       .trim();

//     if (!normalizedEvidence) {
//       return;
//     }

//     // Escape regex special characters
//     const escapedEvidence = normalizedEvidence.replace(
//       /[.*+?^${}()|[\]\\]/g,
//       "\\$&"
//     );

//     /*
//       IMPORTANT:
//       Allow the document to have:
//         space
//         newline
//         literal \n
//         <br>
//         <br />
//         <br/>
//     */
//     const flexiblePattern = escapedEvidence.replace(
//       /\s+/g,
//       "(?:\\s|\\\\n|<br\\s*/?>)+"
//     );

//     const regex = new RegExp(
//       `(${flexiblePattern})`,
//       "gi"
//     );

//     result = result.replace(
//       regex,
//       `<span class="ai-evidence-highlight">$1</span>`
//     );
//   });

//   return result;
// };
 // Matches bracketed redaction markers like [REDACTED], [REDACTED: reason], [Redacted]
const REDACTED_PATTERN = /\[\s*REDACTED[^\]]*\]/gi;

const highlightRedactedText = (html) => {
  if (!html) return html;
  return html.replace(
    REDACTED_PATTERN,
    (match) => `<span class="document-redacted-highlight">${match}</span>`
  );
};

 const normalizeInvisibleChars = (text) =>
  text
    .replace(/\u00AD/g, "")
    .replace(/[\u200B-\u200D\uFEFF]/g, "")
    .replace(/\u00A0/g, " ");

// SINGLE definition — split on pipe, em/en-dash, then ellipsis connectors
const splitEvidenceIntoFragments = (line) =>
  line
    .split(/\s*\|\s*/g)
    .flatMap((part) => part.split(/\s+[—–]\s+/g))
    .flatMap((part) => part.split(/\s*(?:…|\.\.\.+)\s*/g));

const highlightEvidenceText = (documentText, evidence, searchTerm) => {
  if (!documentText || !evidence) {
    return documentText;
  }

  const cleanedEvidence = evidence
    .replace(/\\n/g, "\n")
    .replace(/\*\*/g, "")
    .replace(/\\+$/g, "")
    .trim();

  const evidenceParts = cleanedEvidence
    .split(/\r?\n/)
    .flatMap((line) => splitEvidenceIntoFragments(line))
    .map((text) => text.trim())
    .map((text) => text.replace(/^["'“”‘’]+|["'“”‘’]+$/g, "").trim())
    // CHANGED — do NOT strip [REDACTED] out of fragments that contain real
    // text alongside it (the bracket is often literally present in the
    // document too, standing in for a redacted name/value inline in a real
    // sentence). Only drop a fragment if it's *purely* a marker with
    // nothing else worth matching.
    .filter((text) => {
      if (!text || text === "...") return false;
      const withoutMarkers = text.replace(REDACTED_PATTERN, "").trim();
      return withoutMarkers.length > 2;
    })
    .map((text) => text.replace(/\s+/g, " ").trim());

  const normalizedDocumentText = normalizeInvisibleChars(documentText);
  let result = normalizedDocumentText;

  evidenceParts.forEach((evidencePart) => {
    const normalizedEvidence = normalizeInvisibleChars(evidencePart)
      .replace(/\s+/g, " ")
      .trim();
    if (!normalizedEvidence) return;

    const escapedEvidence = normalizedEvidence.replace(
      /[.*+?^${}()|[\]\\]/g,
      "\\$&"
    );

    const flexiblePattern = escapedEvidence.replace(
      /\s+/g,
      "(?:\\s|\\\\n|<br\\s*/?>)+"
    );

    const regex = new RegExp(`(${flexiblePattern})`, "gi");

    result = result.replace(
      regex,
      `<span class="ai-evidence-highlight">$1</span>`
    );
  });

  result = highlightRedactedText(result);

  if (searchTerm && searchTerm.trim() !== "") {
    const div = document.createElement("div");
    div.innerHTML = result;
    const textNodes = (node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        const parts = node.textContent.split(new RegExp(`(${searchTerm})`, "gi"));
        const fragment = document.createDocumentFragment();
        parts.forEach((part) => {
          if (part.toLowerCase() === searchTerm.toLowerCase()) {
            const span = document.createElement("span");
            span.style.backgroundColor = "lightgreen";
            span.textContent = part;
            fragment.appendChild(span);
          } else {
            fragment.appendChild(document.createTextNode(part));
          }
        });
        node.replaceWith(fragment);
      } else {
        node.childNodes.forEach(textNodes);
      }
    };
    textNodes(div);
    result = div.innerHTML;
  }

  return result;
};
// const highlightEvidenceText = (documentText, evidence) => {
//   if (!documentText || !evidence) {
//     return documentText;
//   }

//   const cleanedEvidence = evidence
//     .replace(/\\n/g, "\n")
//     .replace(/\*\*/g, "")
//     .replace(/\\+$/g, "")
//     .trim();

//   const evidenceParts = cleanedEvidence
//     .split(/\r?\n/)
//     .map((text) => text.trim())
//     .map((text) =>
//       text.replace(/^["'“”‘’]+|["'“”‘’]+$/g, "").trim()
//     )
//     .filter(
//       (text) =>
//         text &&
//         text !== "..." &&
//         text.length > 2 &&
//         !REDACTED_PATTERN.test(text) // NEW — skip lines that are just a redaction marker
//     );

//   // NEW — reset lastIndex since REDACTED_PATTERN is a global regex reused with .test()
//   REDACTED_PATTERN.lastIndex = 0;

//   let result = documentText;

//   evidenceParts.forEach((evidencePart) => {
//     const normalizedEvidence = evidencePart.replace(/\s+/g, " ").trim();
//     if (!normalizedEvidence) return;

//     const escapedEvidence = normalizedEvidence.replace(
//       /[.*+?^${}()|[\]\\]/g,
//       "\\$&"
//     );

//     const flexiblePattern = escapedEvidence.replace(
//       /\s+/g,
//       "(?:\\s|\\\\n|<br\\s*/?>)+"
//     );

//     const regex = new RegExp(`(${flexiblePattern})`, "gi");

//     result = result.replace(
//       regex,
//       `<span class="ai-evidence-highlight">$1</span>`
//     );
//   });

//   return highlightRedactedText(result); // still applies redaction styling separately
// };
  const highlightText = (documentText, searchTerm) => {
    // const text = documentText.replace(/\r\n|\r|\n/g, "<br />");
    // if (!searchTerm) return text; 
    // const parts = text.split(new RegExp(`(${searchTerm})`, 'gi')); 
    
    // return parts.map((part, index) =>
    //   part.toLowerCase() === searchTerm.toLowerCase() ? (
    //     <span key={index} style={{ backgroundColor: 'yellow' }}>{part}</span>
    //   ) : (
    //     part
    //   )
    // );

    if (!searchTerm) return documentText;
    const div = document.createElement('div');
    div.innerHTML = documentText;
    const textNodes = (node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        const parts = node.textContent.split(new RegExp(`(${searchTerm})`, 'gi'));
  
        const fragment = document.createDocumentFragment();
        parts.forEach((part, index) => {
          if (part.toLowerCase() === searchTerm.toLowerCase()) {
            const span = document.createElement('span');
            span.style.backgroundColor = 'yellow';
            span.textContent = part;
            fragment.appendChild(span);
          } else {
            fragment.appendChild(document.createTextNode(part));
          }
        });
  
        node.replaceWith(fragment);
      } else {
        node.childNodes.forEach(textNodes);
      }
    };
  
    textNodes(div);
  
    return div.innerHTML;
  };

  const highlightHtmlText = (html, documentData, searchTerm) => {
    let document_codes = documentData.reasonings.map((item) => item.document_codes);
    // let newDocumentCodes = document_codes.reverse();
    // console.log(document_codes, 'document_codes')
    // console.log(newDocumentCodes, 'newDocumentCodes')
    // console.log(document_codes, 'document_codes')
    
    let newStr = html;
    let counter = 0; // A counter to loop through document_codes
    
    const updatedText = newStr.replace(/<span(.*?)style=['"](.*?background-color:.*?)['"](.*?)>/g, (match, p1, p2, p3) => {
      const documentCode = document_codes[counter % document_codes.length];  
      
      counter++;
    
      return `<span${p1} style='${p2}' data-tooltip='${documentCode}' ${p3}>`;
    });
    
    
    if (!searchTerm) return updatedText;
    const div = document.createElement('div');
    div.innerHTML = updatedText;
    const textNodes = (node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        const parts = node.textContent.split(new RegExp(`(${searchTerm})`, 'gi'));
  
        const fragment = document.createDocumentFragment();
        parts.forEach((part, index) => {
          if (part.toLowerCase() === searchTerm.toLowerCase()) {
            const span = document.createElement('span');
            span.style.backgroundColor = 'lightgreen';
            span.textContent = part;
            fragment.appendChild(span);
          } else {
            fragment.appendChild(document.createTextNode(part));
          }
        });
  
        node.replaceWith(fragment);
      } else {
        node.childNodes.forEach(textNodes);
      }
    };
  
    textNodes(div);
  
    return div.innerHTML;
  };  

  return (
       <div className="document-viewer-section">
        <div className="document-viewer-search">
          <span className="document-viewer-search-icon">
            <img className="document-viewer-search-img" src={searchIcon} />
          </span>
          <input
            className="document-viewer-search-input"
            placeholder="Search"
            autoComplete="off"
            name="documentviewerSearchValue"
            value={documentviewerSearchValue}
            onChange={documentSearchHandler}
          />
        </div>
        <div className="document-viewer-accordion-section">
          {documentViewerDataLoader || aiDocumentLoading ? (
            <div className="document-viewer-loader">
              <LdsRoller/>{" "}
            </div>
          ) : documentViewerDataError ? (
            <div className="document-viewer-error">
              <p>{documentViewerDataError}</p>
            </div>
          ) : (
            <Accordion
  className="document-viewer-accordion-container"
  activeKey={documentviewerEventKey}
>
  {filteredDocumentsList?.length > 0 ? (
    filteredDocumentsList
      .filter((documentData) => {
        // NORMAL MODE
        // Show all documents
        if (!isAIReasoningMode) {
          return true;
        }

        // AI MODE
        // Show ONLY the document selected from AI justification
        return (
          documentData?.document_name ===
          aiJustificationData?.document_name
        );
      })
      .map((documentData, index) => {
        // Check whether this is the AI selected document
        const isAIDocument =
          isAIReasoningMode &&
          documentData?.document_name ===
            aiJustificationData?.document_name;

        return (
          <Card
            key={documentData.document_patient_document_id}
            className="document-viewer-accordion-card"
          >
            <Card.Header className="document-viewer-accordion-header">
              <div className="document-accordion-section">

                {/* DOCUMENT NAME */}
                <div className="document-viewer-btn">
                  {documentData?.document_name
                    ?.replace(".txt", "")
                    ?.slice(
                      documentData?.document_name?.indexOf("-") + 1
                    )
                    .replaceAll("_", " ")}
                </div>

                <div>
                  {/* DOCUMENT IS OPEN */}
                  {documentviewerEventKey ===
                  documentData?.document_patient_document_id ? (
                    <div>

                      {/* OPEN DOCUMENT IN NEW WINDOW */}
                      <a
                        onClick={() =>
                          documentSelectedHandler(documentData)
                        }
                        className="externalLink-btn"
                      >
                        <img
                          src={externalIcon}
                          alt="External Link"
                        />
                      </a>

                      {/* AI MODE CLOSE BUTTON */}
                      {isAIReasoningMode && (
                        <button
                          type="button"
                          className="ai-reasoning-close-btn"
                          onClick={() => {
                            // Clear AI data
                            dispatch(
                              resetAIJustificationData()
                            );

                            // Close accordion
                            dispatch(
                              setDocumentviewerEventKey(null)
                            );

                            // Clear selected document
                            dispatch(
                              setDocumentviewerSelectedDocumentData(
                                {
                                  documentID: null,
                                  documentContent: "",
                                  documentName: "",
                                }
                              )
                            );
                          }}
                        >
                          ×
                        </button>
                      )}

                      {/* NORMAL MODE MINUS BUTTON */}
                      {!isAIReasoningMode && (
                        <button
                          className="document-accordion-minus-icon"
                          onClick={() =>
                            toggleAccordion(
                              documentData?.document_patient_document_id
                            )
                          }
                        >
                          <img
                            src={minsIcon}
                            alt="-"
                          />
                        </button>
                      )}
                    </div>
                  ) : (
                    /* DOCUMENT IS CLOSED */
                    !isAIReasoningMode && (
                      <div className="accordion-header-btn">
                        <button
                          className="document-accordion-plus-icon"
                          onClick={() => {
                            toggleAccordion(
                              documentData?.document_patient_document_id
                            );

                            const selectedData = {
                              documentID:
                                documentData?.document_patient_document_id,

                              documentContent:
                                documentData?.document_text,

                              documentName:
                                documentData?.document_name
                                  ?.replace(".txt", "")
                                  ?.slice(
                                    documentData?.document_name?.indexOf(
                                      "-"
                                    ) + 1
                                  ),
                            };

                            dispatch(
                              setDocumentviewerSelectedDocumentData(
                                selectedData
                              )
                            );
                          }}
                        >
                          <img
                            src={plusIcon}
                            alt="+"
                          />
                        </button>
                      </div>
                    )
                  )}
                </div>
              </div>
            </Card.Header>

            {/* DOCUMENT CONTENT */}
            <Accordion.Collapse
              eventKey={
                documentData?.document_patient_document_id
              }
            >
              <Card.Body
                className="document-viewer-accordion-card-body"
                ref={(el) =>
                  (cardRefs.current[
                    documentData?.document_patient_document_id
                  ] = el)
                }
                onScroll={() =>
                  checkCardHeight(
                    documentData?.document_patient_document_id
                  )
                }
              >

                {/* DOCUMENT COLOURED TEXT */}
                {documentData?.document_coloured_text !== null ? (
                  <div
                    className="document-viewer-accordion-text"
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(
                        isAIDocument
                          ? highlightEvidenceText(
                              documentData?.document_coloured_text.replace(
                                /\r\n|\r|\n/g,
                                "<br />"
                              ),
                              aiJustificationData?.evidence,
                              documentviewerSearchValue
                            )
                          : highlightHtmlText(
                              documentData?.document_coloured_text.replace(
                                /\r\n|\r|\n/g,
                                "<br />"
                              ),
                              documentData,
                              documentviewerSearchValue
                            )
                      ),
                    }}
                  />
                ) : (

                  /* NORMAL DOCUMENT TEXT */
                  <div className="document-viewer-accordion-text">
                    <span
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(
                          isAIDocument
                            ? highlightEvidenceText(
                                documentData?.document_text.replace(
                                  /\r\n|\r|\n/g,
                                  "<br />"
                                ),
                                aiJustificationData?.evidence,
                                documentviewerSearchValue
                              )
                            : highlightText(
                                documentData?.document_text.replace(
                                  /\r\n|\r|\n/g,
                                  "<br />"
                                ),
                                documentviewerSearchValue
                              )
                        ),
                      }}
                    />
                  </div>
                )}
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        );
      })
  ) : (
    <p className="document-no-data-found">
      No matching documents found.
    </p>
  )}
</Accordion>
          )}
          {aiJustificationData?.justification && (
  <div className="ai-reasoning-container">
    <div className="ai-reasoning-header">
      <span className="ai-reasoning-icon">
        🤖
      </span>

      <span>AI Reasoning</span>
    </div>

    <div className="ai-reasoning-body">
      <div className="ai-justification-text">
        {aiJustificationData.justification}
      </div>
    </div>
  </div>
)}
          {/* Reasoning Accordion */}
         {/* {!documentViewerDataLoader &&  filteredDocumentsList?.length > 0 &&  <Accordion className="document-viewer-accordion-reasoning-container" activeKey={documentviewerEventKey}>
                <Card className="document-viewer-accordion-reasoning-card">
                  <Card.Header className="document-viewer-accordion-reasoning-header">
                    <div className="document-accordion-section">
       
                      <div>
                        {documentviewerEventKey !== null &&
                        documentviewerEventKey === documentviewerSelectedDocumentData.documentID ? (
                          <div>

                            <button
                              className="document-accordion-minus-icon"
                              onClick={() =>
                                toggleAccordion(documentviewerSelectedDocumentData.documentID)
                              }
                            >
                              <img src={minsIcon} alt="-" />
                            </button>
                          </div>
                        ) : (
                          <div className="accordion-header-btn">
                            <button
                              className="document-accordion-plus-icon"
                              onClick={() => {
                                toggleAccordion(
                                  documentviewerSelectedDocumentData.documentID
                                );
                              }}
                            >
                              <img src={plusIcon} alt="+" />
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </Card.Header>
                  {documentviewerEventKey !== null && (
                    <Accordion.Collapse
                    eventKey={documentviewerSelectedDocumentData.documentID}
                    >
                      <Card.Body className="document-viewer-accordion-reasoning-card-body">
  
                        {filteredDocumentsList
                          .filter(
                            (item) =>
                              item.document_patient_document_id ===
                            documentviewerSelectedDocumentData.documentID
                          )
                          .map((item) =>
                            item.reasonings.length > 0 ? item.reasonings.map((reasoningsData) => (
                              <>
                                <span className="document-viewer-reasoning-name">
                                  {reasoningsData.group}:
                                </span>
                                <div key={reasoningsData?.reasoning_id}>
                                  <div
                                    className="document-viewer-reasoning-text"
                                    dangerouslySetInnerHTML={{
                                      __html: addTooltipToSpans(
                                        reasoningsData
                                          .document_coloured_reasoning_content
                                          ?.length > 0
                                          ? reasoningsData.document_coloured_reasoning_content
                                          : reasoningsData.document_reasoning_content, reasoningsData.document_codes
                                      ),
                                    }}
                                  />
                                </div>
                              </>
                            ))
                            : <p className="document-viewer-reasoning-text-no-data">No reasonings found</p>)}
                      </Card.Body>
                    </Accordion.Collapse>
                  )}
                </Card>
              </Accordion>} */}
        </div>
          {!isAIReasoningMode&&!aiDocumentLoading&& <Pagination className="document-viewer-pagination">
            <Pagination.Prev
              onClick={() => handleDocumentViewerPageChange(documentviewerCurrentPage - 1)} disabled={documentviewerCurrentPage === 1}
            className="document-viewe-prev-btn"
            />
            {`Showing ${start} - ${end} of ${totalDocuments}`}
            {/* {`showing ${start}- ${end ? end : 0} of ${documentViewerData?.total_documents > 0 ? documentViewerData?.total_documents : 0}`} */}
            {/* {documentViewerData?.total_documents > 5 && `showing ${documentviewerCurrentPage}-${} of ${totalPages}`} */}
            <Pagination.Next
            onClick={() => handleDocumentViewerPageChange(documentviewerCurrentPage + 1)} disabled={documentviewerCurrentPage === totalPages || totalPages === 0}
            // onClick={() => handleDocumentViewerPageChange(documentviewerCurrentPage + 1)}  disabled={documentviewerCurrentPage === 1 || documentviewerCurrentPage === totalPages || totalPages === 0}
            className="document-viewe-next-btn"
            />
          </Pagination>}
      </div>
  );
};

export default DocumentViewer;
